module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 11
// module chunks = 0